﻿import * as React from 'react';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';

type BaseTabProps = {
    onClick: any;
    route: string;
    label: string;
};

let StyledBaseTab = styled(Tab)(({ theme }) => ({
    fontSize: '14px',
    [theme.breakpoints.up('sm')]: {
        minWidth: '150px'
    },
    '&:hover': {
        backgroundColor: '#343F45'
    }
}));

const BaseTab = ({ onClick, route, label, ...props }: BaseTabProps) => {
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        let ctrlKey: boolean = event.ctrlKey;

        return ctrlKey && route != null ? window.open(route, '_blank') : onClick(event);
    };

    return <StyledBaseTab {...props} label={label} onClick={handleClick} />;
};

export default BaseTab;
